<p-panelMenu class="panel-menu" [model]="menu" multiple transitionOptions="100ms cubic-bezier(0.86, 0, 0.07, 1)">
  <ng-template pTemplate="item" let-item>
    @if (item.items) {
      <a class="panel-menu__header-action">
        <span>{{ item.label }}</span>
        @if (item.expanded) {
          <ChevronDownIcon class="panel-menu__header-action-icon" />
        } @else {
          <ChevronRightIcon class="panel-menu__header-action-icon" />
        }
      </a>
    } @else {
      <a [routerLink]="item.routerLink" routerLinkActive="panel-menu__item-link--active" class="panel-menu__item-link">
        <span class="panel-menu__item-link-text">{{ item.label }}</span>
        <StarFillIcon
          class="panel-menu__item-link-icon"
          lhStarIconStyles
          [menuItem]="item"
          [favouriteSubmenu]="favouriteSubmenu"
          (click)="starIconClick.emit({ event: $event, menuItem: item })"
        />
      </a>
    }
  </ng-template>
</p-panelMenu>
